import { render, staticRenderFns } from "./inputNote.vue?vue&type=template&id=3e8272d4&"
import script from "./inputNote.vue?vue&type=script&lang=js&"
export * from "./inputNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports